import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import config from '../configuration/config.json';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Buffer } from 'buffer';
import { Base64 } from 'js-base64';
import { v4 as uuidv4 } from 'uuid';
import './IDProofing.css';
import { Row, Col, Button, Alert, Card } from 'react-bootstrap';

Base64.extendUint8Array();

function StartIDProofingCHV() {
    const title = 'goID ID Proofing Portal';
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [applink, setApplink] = useState("");
    const [cardType, setCardType] = useState("");
    const [isNFC, setIsNFC] = useState(false);
    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [sedForChvScenario, setSedForChvScenario] = useState(false);
    const [aidForChvScenario, setAidForChvScenario] = useState("");
    const appMode = localStorage.getItem('AppMode');
    const [isAppOpened, setisAppOpened] = useState(false);

    let { aid } = useParams();
  

    useEffect(() => {
        let cardType = localStorage.getItem('CardType');
        setCardType(cardType);

        if (window.location.href.replaceAll(' ', '').includes('checkstatus')) {
            (async () => {
                try {
                    await checkCHVDataExists();
                } catch (err) {
                    console.error(err);
                }
            })();
          
        } else if (window.location.href.replaceAll(' ', '').includes('chvscenario')) {
            navigate('/idproofing/selfi/' + aid);
        } else {

            let verifier = config.idproofing.verifiers.qrcode.find(v => v.cardType == cardType);
            if (verifier) {
                startVerify(verifier.id);
            }
            else {
                setIsNFC(true);
                getNFCDeeplink();
            }
        }
    }, []);

    async function startVerify(verifierid) {

        try {
            let headers = {
                'Authorization': "Bearer " + config.idproofing.token,
                "content-type": "application/json",
            };

            let aditionalinfo = {};
            let cardType = localStorage.getItem('CardType');
            aditionalinfo.cardType = cardType;

            const response = await axios.request({
                method: 'POST',
                url: config.idproofing.apibaseurl + "idproofing/qrcode/reader/request/" + verifierid + "/" + aid,
                headers: headers,
                responseType: 'arraybuffer',
                responseEncoding: 'binary',
                data: aditionalinfo,
            });

            if (response.status == 200) {
                let applinkd = new Buffer(response.data);
                var qrData = config.idproofing.deeplinkurl + applinkd.toBase64URL();
                setIsNFC(false);
                setApplink(qrData);
                setIsLoading(false);

            } else {
                setIsLoading(false);
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse)
                setErrorMessage(jsonData.message);
                setShow(true);
            }

        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else { 
                setErrorMessage(e.message);
            }
            setShow(true);
            setIsLoading(false);
        }
    }

    async function getNFCDeeplink() {
        try {
            let headers = {
                'Authorization': "Bearer " + config.idproofing.token
            };
            const response = await axios.request({
                method: 'GET',
                url: config.idproofing.apibaseurl + "idproofing/nfc/" + aid,
                headers: headers,
                responseType: 'application/json'
            });

            let errorMessage = "";
            let variant = 'success';

            if (response.status == 200) {
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse);
                let applinkd = jsonData.redirectUrl;
                setApplink(applinkd);
            } else {
                errorMessage = "Error occured on Verification";
                variant = 'failure';
            }
        } catch (e) {
            setIsLoading(false);
        }
    }

    async function openwebShare(text) {
        try {

            let resultURL = config.idproofing.baseurl + "idproofing/startidproofingchv/checkstatus/" + aid;

            if (window.location.href.replaceAll(' ', '').includes('checkstatus')) {
                resultURL = config.idproofing.baseurl + "idproofing/startidproofingchv/chvscenario/" + aidForChvScenario;
            }

            const shareData = {
                text: text,
               // url: resultURL,
            };

            await navigator.share(shareData);
        } catch (e) {
            setErrorMessage(e.message);
            setShow(true);
        }
    }

    async function checkCHVDataExists() {
        try {
            setIsLoading(true);


            let headers = {
                'Authorization': "Bearer " + config.idproofing.token
            };
            const response = await axios.request({
                method: 'GET',
                url: config.idproofing.apibaseurl + "idproofing/checkchvresult/" + aid,
                headers: headers,
                responseType: 'application/json'
            });

            if (response.status == 200) {

                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse);


                /* To be verified chv is exists or not */
                if (jsonData.chv) {
                    navigate('/idproofing/verification/' + aid);
                }
                else if (jsonData.portrait) {
                    navigate('/idproofing/selfi/' + aid + '/' + jsonData.cardType);
                } else {
                    navigate('/idproofing/verification/' + aid);
                }
            } else {
                setIsLoading(false);
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse);
                setErrorMessage(jsonData.message);
                setShow(true);
            }
            setIsLoading(false);



        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else {
                setErrorMessage(e.message);
            }
            setShow(true);
            setIsLoading(false);
        }
    }

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>

            <main className="mainbg">
                <div class="container-fluid  text-center">
                    <div class="row">
                        <div class="col bannerdisplay">
                            
                            <div className="headerdiv">
                                <h1 className="headerdisplay">{title}</h1>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col scancontentarea">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col">
                                        <div>
                                            <br /><br />
                                            <span>{sedForChvScenario ? "CHV Verification failed." : ""}</span>
                                           
                                            <div class="loader-container">
                                                <div class="loading-text">
                                                    {applink === "" ? <span class="dots">Processing</span> :
                                                        !sedForChvScenario ?
                                                            <div>
                                                                {!isAppOpened &&
                                                                    <Button className="btn btn-primary btn-lg px-4 gap-3"
                                                                        type="button"
                                                                        disabled={isLoading}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            if (appMode == 'D') {
                                                                                window.location.replace(applink);
                                                                            } else {
                                                                                openwebShare(applink)
                                                                            }
                                                                            setisAppOpened(true);
                                                                        }}
                                                                    >
                                                                        <span className="px-2">Read Mobile ID</span>
                                                                    </Button>
                                                                }
                                                            </div>
                                                            : "Opening App for Portrait reading "
                                                    }
                                                    </div>
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                               
                                <div class="row">
                                    <div class="col">
                                      {/*  <hr />*/}
                                        <div>
                                            <span className="instructiondisplay">
                                                    During that step, your wallet app will be requested for the relevant mobile ID attributes to confirm your identity.
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Alert show={show} variant="danger" onClose={() => setShow(false)} dismissible>
                <Alert.Heading>Error!</Alert.Heading>
                <p>
                    {errorMessage}.
                </p>
            </Alert>
        </>
    );
}

export default StartIDProofingCHV;
